// Itens sem recomendação de compra: exibe a quantidade de lotes múltiplos, ex.: "4 lotes (lote 10)"
export const formatLotes = (
  quantidadeLotes?: number | null,
  loteMultiplo?: number | null
): string => {
  if (quantidadeLotes === null || quantidadeLotes === undefined) return '-'

  const format = (value: number) =>
    value.toLocaleString('pt-BR', { maximumFractionDigits: 1 })
  const lotes = `${format(quantidadeLotes)} ${
    quantidadeLotes === 1 ? 'lote' : 'lotes'
  }`
  return loteMultiplo ? `${lotes} (lote ${format(loteMultiplo)})` : lotes
}
